import { observer } from 'mobx-react';
import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import type { LeaveFeedbackModalProps } from './component';

const ComponentLoad = lazy(async () => await import('./component'));

const LeaveFeedbackPopup: FC<LeaveFeedbackModalProps> = observer(props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
));

export default LeaveFeedbackPopup;
